import type { MouseEvent } from 'react'

/** Return the click position from click */
export const getClickPositionSeconds = (
  event: MouseEvent,
  { pixelsPerSecond, duration }: { pixelsPerSecond?: number; duration: number }
) => {
  const rect = event.currentTarget.getBoundingClientRect()
  const pxs = pixelsPerSecond ? pixelsPerSecond : rect.width / duration
  const pos = event.clientX - rect.left
  const clickSec = pos / pxs
  return clickSec
}
